import { motion } from "framer-motion";
import type { Booking } from "@/types/Booking";
import type { Member } from "@/types/Member";

type AmenityBubbleProps = {
  booking: Booking;
  member: Member | null;
  /** Display name of the member the amenity is booked by (parity with room bookings). */
  ownerName?: string;
  top: number;
  height: number;
  allowClick?: boolean;
};

const AmenityBubble = ({ booking, member, ownerName, top, height }: AmenityBubbleProps) => {
  const animationAllowed = member?.settings?.allowAnimation;
  const label = ownerName?.trim() || "Booked";

  const animation = animationAllowed
    ? {
        initial: { opacity: 0, scale: 0.9, skewX: 5 },
        animate: { opacity: 1, scale: 1, skewX: 0 },
      }
    : { initial: {}, animate: {} };

  return (
    <motion.div
      initial={animation.initial}
      animate={animation.animate}
      aria-label={`Amenity booking at ${booking.startTime}${ownerName ? ` — ${label}` : ""}`}
      title={label}
      className={`absolute w-full z-30 left-0 bg-gray-600 rounded text-white text-xs hover:cursor-pointer p-1 flex flex-col pointer-events-auto`}
      style={{
        top: `${top}px`,
        height: `${height}px`,
      }}
    >
      <div className={`text-base flex gap-1`}>{booking.startTime} </div>
      <span className="text-base leading-4 truncate">{label}</span>
    </motion.div>
  );
};

export default AmenityBubble;
